import { actionTypes, applicationActions } from '../../../controller';
import { RouteKeyEnums } from '../../../routes';

const {
	NAVIGATE_TO_OVER_PAGE,
	UPDATE_ME_LANGUAGE_CODE_SUCCESS,
} = actionTypes;
const {
	forceReconnectSocketAction,
	runForceReconnectingSocketStepOneDisconnectAction,
} = applicationActions;
const { CONVERSATION_OVER } = RouteKeyEnums;

export function applicationMiddleware({ dispatch }) {
	return next => action => {
		const { type } = action;

		if (type === NAVIGATE_TO_OVER_PAGE) {
			const baseUrl = `${window.location.origin}/client`;

			window.location.replace(`${baseUrl}${CONVERSATION_OVER}`);
		}

		next(action);

		if (type === UPDATE_ME_LANGUAGE_CODE_SUCCESS) {
			dispatch(forceReconnectSocketAction());
			dispatch(runForceReconnectingSocketStepOneDisconnectAction());
		}
	};
}
